var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_121360_11261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.2881 64.4286C39.2881 65.6789 39.7848 66.878 40.6689 67.7621C41.553 68.6462 42.7521 69.1429 44.0024 69.1429C45.2527 69.1429 46.4518 68.6462 47.3359 67.7621C48.22 66.878 48.7167 65.6789 48.7167 64.4286C48.7167 63.1783 48.22 61.9792 47.3359 61.0951C46.4518 60.211 45.2527 59.7143 44.0024 59.7143C42.7521 59.7143 41.553 60.211 40.6689 61.0951C39.7848 61.9792 39.2881 63.1783 39.2881 64.4286V64.4286ZM40.8596 34.5714V52.6429C40.8596 53.075 41.2131 53.4286 41.6453 53.4286H46.3596C46.7917 53.4286 47.1453 53.075 47.1453 52.6429V34.5714C47.1453 34.1393 46.7917 33.7857 46.3596 33.7857H41.6453C41.2131 33.7857 40.8596 34.1393 40.8596 34.5714ZM87.5801 77.7857L46.723 7.07143C46.114 6.02054 45.0631 5.5 44.0024 5.5C42.9417 5.5 41.881 6.02054 41.2819 7.07143L0.424742 77.7857C-0.783294 79.8875 0.729206 82.5 3.14528 82.5H84.8596C87.2756 82.5 88.7881 79.8875 87.5801 77.7857ZM10.6292 75.0455L44.0024 17.2759L77.3756 75.0455H10.6292V75.0455Z",
    fill: "#CC4747"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_121360_11261"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.02fc7bf3.svg";
export { ForwardRef as ReactComponent };